import { render, staticRenderFns } from "./PageServices1C.vue?vue&type=template&id=eaf5e49c&scoped=true&"
import script from "./PageServices1C.vue?vue&type=script&lang=js&"
export * from "./PageServices1C.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf5e49c",
  null
  
)

export default component.exports